import axios from '@/axios'

export default class GraphqlApi {
  post(query, variables = {}, operationName) {
    return new Promise((resolve, reject) => {
      axios.post('/graphql_public', { query, variables, operationName }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject();
        console.warn(error);
      })
    })
  }
}
